/**
 * An angularjs module implementing the voyager router.
 * @module
 */
const ngModuleName = 'voyager';
import { run } from './run';
import { onswViewComponent } from './view';
import { atRouteDirective } from './at-route';
export default ngModuleName;
export { rootRoute } from '../root';
// TODO add bounty for angular.module
if (!('angular' in window)) {
    console.error('angularjs not found');
}
window.angular
    .module(ngModuleName, ['ng', 'ngAnimate'])
    .directive('atRoute', atRouteDirective)
    .component('onswView', onswViewComponent)
    .run(run);
